// Migration note: '@babel/polyfill' has been replaced with 'core-js/stable'.
import 'core-js/stable'
import Vue from 'vue'
import App from './App.vue'
import { routerWithKeycloak, router } from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { i18nWithKeycloak } from '@/plugins/i18n'

import VueMultianalytics from 'vue-multianalytics'
import analyticsMixin from './mixins/analyticsMixin.js'
import googleAnalyticsConfig from './config/googleAnalyticsConfig'
import VueKeyCloak from '@dsb-norge/vue-keycloak-js'
import { tokenInterceptor } from '@/script/axiosConfig'
import { authenticatedKeycloak } from '@/script/keycloak.js'
import 'vuetify/dist/vuetify.min.css'

import { launchBugSnag, setUserBugSnag } from './script/bugSnag'

export const bus = new Vue()

const token = localStorage.getItem('token')
const refreshToken = localStorage.getItem('kc_refreshToken')

Vue.use(
  VueMultianalytics,
  {
    modules: {
      ga: googleAnalyticsConfig
    },
    routing: {
      vueRouter: router
    }
  },
  analyticsMixin
)

Vue.use(VueKeyCloak, {
  config: {
    url: process.env.VUE_APP_AUTH_URL,
    realm: process.env.VUE_APP_AUTH_REALM,
    clientId: process.env.VUE_APP_AUTH_CLIENT_ID
  },
  init: { onLoad: 'check-sso', token: token, refreshToken: refreshToken, checkLoginIframe: false },
  onReady: (keycloak) => {
    keycloak.createLogoutUrl = (_) => {
      if (!keycloak.idToken) {
        return window.location.origin
      }

      return (
        keycloak.endpoints.logout() +
        '?id_token_hint=' +
        keycloak.idToken +
        '&post_logout_redirect_uri=' +
        encodeURIComponent(process.env.VUE_APP_AUTH_LOGOUT_REDIRECT_URI)
      )
    }
    authenticatedKeycloak(keycloak, store)
    tokenInterceptor(keycloak)
    setUserBugSnag(store.state.user)

    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router: routerWithKeycloak(keycloak),
      store,
      i18n: i18nWithKeycloak(store),
      template: '<App/>',
      vuetify,
      render: (h) => h(App)
    })
  }
})
